document.addEventListener("DOMContentLoaded", () => {

  const popup = document.querySelector(".results-popup");
  const popupImage = document.querySelector(".results-popup__image");
  const close = document.querySelector(".results-popup__close");

  if (!popup || !popupImage) return;

  document.querySelectorAll(".results-gallery__img").forEach((image) => {

    image.addEventListener("click", () => {

      popup.classList.add("active");

      popupImage.src = image.src;

      popupImage.alt = image.alt;

      document.body.style.overflow = "hidden";

    });

  });

  function closePopup(){

    popup.classList.remove("active");

    popupImage.src = "";

    document.body.style.overflow = "";

  }

  close.addEventListener("click", closePopup);

  popup.addEventListener("click",(e)=>{

    if(e.target===popup){

      closePopup();

    }

  });

  document.addEventListener("keydown",(e)=>{

    if(e.key==="Escape"){

      closePopup();

    }

  });

});